import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Carousel = React.lazy(() => import(/* webpackChunkName: "builder-carousel" */ '@brainhubeu/react-carousel'));
const CarouselDots = React.lazy(() => import(/* webpackChunkName: "builder-carousel-dots" */ './CarouselDots'));
import '@brainhubeu/react-carousel/lib/style.css';
import './style.scss';
import styles from './style.module.scss';

const BundleGallery = (props) => {
  const {
    products,
    fullscreenGallery,
  } = props;
  const [slideIndex, setSlideIndex] = useState(0);
  const onChange = slideIndex => setSlideIndex(slideIndex);

  if(!(products.length > 0)) {
    return (
        <>
            {window.skatehutBuilder.builderStartImage && (
                <figure className={styles.layerImage}>
                    <img alt="" src={window.skatehutBuilder.builderStartImage} className={styles.placeHolder} />
                 </figure>
            )}
        </>
    );
  }

  return (
    <div className={fullscreenGallery ? styles.carouselWrapper__fullscreen : styles.carouselWrapper}>
      <Carousel
        plugins={['arrows']}
        value={slideIndex}
        onChange={onChange}
      >
        {products.map((product => (
          <img src={product.productThumb} alt={product.name} />
        )))}
      </Carousel>
      <CarouselDots
        value={slideIndex}
        onChange={onChange}
        number={products.length}
      />
    </div>
  );
};

BundleGallery.propTypes = {
  products: PropTypes.arrayOf({
    name: PropTypes.string,
    productThumb: PropTypes.string,
  }),
  isBigScreen: PropTypes.bool,
  fullscreenGallery: PropTypes.bool,
};

BundleGallery.defaultProps = {
  products: [],
  isBigScreen: false,
  fullscreenGallery: false,
};

export default BundleGallery;
